export default __webpack_public_path__ + "static/media/search.ca0716cb.svg";